module.exports = __webpack_public_path__ + "media/images/teaching-bg-ccc92c3993385d02f0c734929d83cd8a.jpg";